



































import {Vue, Component} from 'vue-property-decorator';
import ContractorServiceLogList from "@/components/payroll/business/services/ContractorServiceLogList.vue";
import EmployerServiceLogList from "@/components/payroll/business/services/EmployerServiceLogList.vue";
import InvoiceCreationSlider from "@/components/payroll/business/services/invoice/InvoiceCreationSlider.vue";
import InvoiceList from "@/components/payroll/business/services/invoice/InvoiceList.vue";
import ServiceInvoiceOrchestrator from "@/services/ServiceInvoiceOrchestrator";
import {InvoiceSummary} from "@/components/payroll/business/services/ServiceDTO";
import {processError} from "@/utils/ComponentUtils";
import Application from "@/state/Application";

type Tabs = "INVOICES" | "SERVICE_LOGS"

@Component({
	components: {InvoiceList: InvoiceList, InvoiceCreationSlider, EmployerServiceLogList, ContractorServiceLogList}
})
export default class Invoices extends Vue {

	private currentTab: Tabs = "INVOICES"

	private setTab(tab: Tabs) {
		this.currentTab = tab
	}

	private unpaid: InvoiceSummary | null = null
	private paid: InvoiceSummary | null = null

	mounted() {
		this.loadTotal()
	}

	private loadTotal() {
		this.loadUnpaidTotal()
		this.loadPaidTotal()
	}

	private loadUnpaidTotal() {
		return ServiceInvoiceOrchestrator.getUnpaidTotal(this.$wss.getCurrent.id).then(
			res => {
				this.unpaid = res.data
			},
			err => processError(err, this)
		)
	}

	private loadPaidTotal() {
		return ServiceInvoiceOrchestrator.getPaidTotal(this.$wss.getCurrent.id).then(
			res => {
				this.paid = res.data
			},
			err => processError(err, this)
		)
	}

	get unpaidValue(): string {
		if (this.unpaid) {
			return "$" + this.unpaid.payee.toLocaleString("en-US", { minimumFractionDigits: 2 })
		} else {
			return "$0.00"
		}
	}

	get paidValue(): string {
		if (this.paid) {
			return "$" + this.paid.payee.toLocaleString("en-US", { minimumFractionDigits: 2 })
		} else {
			return "$0.00"
		}
	}

}
